import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/800.css";
import "@fontsource/poppins/900.css";
import { setupIonicReact } from "@ionic/react";
import "@ionic/react/css/core.css";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";
import "./index.css";
import App from "./App";
import { LangProvider } from "./i18n";
import { LoadingProvider } from "./context/LoadingContext";
import { MiProvider } from "./context/MiContext";
import MiSystemShell from "./components/MiSystemShell";
import ErrorBoundary from "./components/ErrorBoundary";

console.info("GPH UI build marker:", "GPH_UI_REFAC_2026_06_05_BLOCK15");
setupIonicReact({ mode: "ios" });

// Register PWA Service Worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const SW_RESET_KEY = 'gph_sw_cache_reset_v6';
    let reloadingForSwUpdate = false;

    const forceCacheResetOnce = async () => {
      try {
        if (localStorage.getItem(SW_RESET_KEY) === '1') return;
        if (!('caches' in window)) return;
        const cacheKeys = await caches.keys();
        await Promise.all(
          cacheKeys.map((key) => caches.delete(key))
        );
        localStorage.setItem(SW_RESET_KEY, '1');
        console.log('SW cache reset completed');
      } catch (err) {
        console.warn('SW cache reset skipped:', err);
      }
    };

    const promoteWaitingWorker = (registration) => {
      if (registration?.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
    };

    const installUpdateListener = (registration) => {
      registration.addEventListener('updatefound', () => {
        const worker = registration.installing;
        if (!worker) return;
        worker.addEventListener('statechange', () => {
          if (worker.state === 'installed' && navigator.serviceWorker.controller) {
            promoteWaitingWorker(registration);
          }
        });
      });
    };

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloadingForSwUpdate) return;
      reloadingForSwUpdate = true;
      window.location.reload();
    });

    forceCacheResetOnce()
      .finally(() => {
        navigator.serviceWorker.register('/service-worker.js')
          .then((reg) => {
            console.log('SW registered:', reg.scope);
            promoteWaitingWorker(reg);
            installUpdateListener(reg);
          })
          .catch((err) => console.log('SW registration failed:', err));
      });
  });
}

// Capture PWA install prompt globally before React mounts.
window.__pwaInstallPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__pwaInstallPrompt = e;
  console.log('PWA beforeinstallprompt captured globally');
});

const root = ReactDOM.createRoot(document.getElementById("root"));
document.documentElement.classList.add("gph-react-ready");
document.getElementById("seo-prerender")?.remove();
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <MiProvider>
        <LoadingProvider>
          <LangProvider>
            <MiSystemShell>
              <App />
            </MiSystemShell>
          </LangProvider>
        </LoadingProvider>
      </MiProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
